import { jsx, jsxs } from 'react/jsx-runtime';
import { DismissableLayerBranch } from '@radix-ui/react-dismissable-layer';
import { useRef, useEffect } from 'react';
import { Flex } from '../layout/Flex.mjs';
import { StyledRoot, StyledTitleRoot } from './styled.mjs';
import TimeoutContainer from './TimeoutContainer.mjs';

function ToastContent(props) {
  const { toast, hide, role = "status", shouldHide } = props;
  const timeoutContainerRef = useRef(null);
  const { autoClose = 3e3, content, leftSlot, rightSlot } = toast;
  useEffect(() => {
    if (shouldHide) {
      timeoutContainerRef.current?.hide();
    }
  }, [shouldHide]);
  return (
    /**
     * https://linear.app/flexteam/issue/FX-251/toastcontext에-dismissable-layer-scope-생성
     *
     * - modality가 있는 popper가 뜬 상태에서 생성된 toast에 대한 인터렉션이 outside click으로 인식되지 않게 하기 위함
     * - modality가 있는 popper가 뜬 상태에서도 toast의 인터렉션이 가능하게 하기 위해 pointer-events 재설정
     */
    /* @__PURE__ */ jsx(DismissableLayerBranch, { style: { pointerEvents: "auto" }, children: /* @__PURE__ */ jsx(
      TimeoutContainer,
      {
        ref: timeoutContainerRef,
        toast,
        onHide: hide,
        autoClose,
        role,
        "aria-live": role === "alert" ? "assertive" : "polite",
        children: /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "center", children: [
          leftSlot && /* @__PURE__ */ jsx(
            StyledRoot,
            {
              align: "center",
              justify: "center",
              style: { marginRight: 10 },
              children: leftSlot
            }
          ),
          /* @__PURE__ */ jsx(StyledTitleRoot, { children: content }),
          rightSlot && /* @__PURE__ */ jsx(
            StyledRoot,
            {
              align: "center",
              justify: "center",
              style: { marginLeft: 8 },
              children: rightSlot
            }
          )
        ] })
      },
      toast.id
    ) })
  );
}

export { ToastContent as default };
//# sourceMappingURL=ToastContent.mjs.map
